import { useEffect, useState } from "react";
import { Grid, Link, Typography } from "@mui/material";
import ListResponsive from "../../../components/other/ListResponsive";
import moment from "moment";
import "moment-timezone";
import { BCPSquarePlus } from "../../../components/icons/bcp/BCPIcons";
import { getData } from "../../../components/utilities/UtilityFunctions";

const searchLimitAdmin = 100;
const searchLimitUser = 20;

export default function StoreTransactionsList(props) {
  const { isAdmin, query } = props;

  const [transactions, setTransations] = useState(null);
  const [nextKey, setNextKey] = useState(null);
  const [endOfTransactions, setEndOfTransactions] = useState(false);

  const fetchData = async () => {
    const queryStringParameters = {
      limit: isAdmin === true ? searchLimitAdmin : searchLimitUser,
      ...query,
    };
    if (nextKey) {
      queryStringParameters.nextKey = nextKey;
    }
    var firstFetch = await getData("/storetransactions", {
      queryStringParameters: queryStringParameters,
    });

    if (nextKey && firstFetch.nextKey === nextKey) {
      setEndOfTransactions(true);

      return;
    }

    var newData;
    if (transactions?.length > 0) {
      newData = [...transactions, ...firstFetch.data];
    } else {
      newData = firstFetch.data;
    }

    setTransations(newData);

    if (
      firstFetch.data?.length !== 0 &&
      firstFetch.nextKey &&
      firstFetch.nextKey !== nextKey
    ) {
      setNextKey(firstFetch.nextKey);
      var secondFetch = await getData("/storetransactions", {
        queryStringParameters: {
          ...queryStringParameters,
          nextKey: firstFetch.nextKey,
          limit: 1,
        },
      });
      if (secondFetch.data?.length === 0) {
        setEndOfTransactions(true);
      }
    } else {
      setEndOfTransactions(true);
    }

    return;
  };

  useEffect(() => {
    const go = async () => {
      await fetchData();
    };
    go();
    // eslint-disable-next-line
  }, []);

  return (
    <ListResponsive
      originalList={transactions}
      doSearch
      doPages
      pagingFunction={fetchData}
      endOfPaging={endOfTransactions}
      rowsPerPageArray={null}
      initialRowsPerPage={isAdmin === true ? searchLimitAdmin : searchLimitUser}
      actionButton={
        isAdmin === true
          ? {
              props: {
                variant: "contained",
                color: "primary",
                fullWidth: true,
                href: "/admin/shop/transaction",
                startIcon: <BCPSquarePlus />,
              },
              label: "New Transactions",
            }
          : null
      }
      searchProps={{
        label: "Search Transactions",
        performSearch: (originalList, searchText) => {
          if (!searchText || searchText === "") {
            return originalList;
          } else {
            var filteredList = originalList.filter(function (el) {
              if (el?.orderId?.toLowerCase().includes(searchText)) return true;
              if (el?.transactionType?.toLowerCase().includes(searchText))
                return true;
              if (el?.status?.toLowerCase().includes(searchText)) return true;
              if (el?.firstName?.toLowerCase().includes(searchText))
                return true;
              if (el?.lastName?.toLowerCase().includes(searchText)) return true;

              return false;
            });
            return filteredList;
          }
        },
      }}
      rowProps={{
        headings: <RowItem heading isAdmin={isAdmin} />,
        mapFunction: (row, index) => (
          <RowItem key={index} row={row} isAdmin={isAdmin} />
        ),
      }}
    />
  );
}

const RowItem = (props) => {
  const { heading, row, isAdmin } = props;

  const Content = () => {
    return (
      <Grid
        container
        spacing={1}
        sx={{
          p: 1,
          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        }}
      >
        <Grid item xs={3}>
          {heading ? (
            <Typography variant="body1">Transaction</Typography>
          ) : (
            <>
              <Typography variant="body1">
                {row?.orderId?.toUpperCase()}
              </Typography>
              {isAdmin === true && (
                <Typography variant="caption">
                  {`${row?.firstName} ${row?.lastName}`}
                </Typography>
              )}
            </>
          )}
        </Grid>
        <Grid item xs={3}>
          {heading ? (
            <Typography variant="body1">Date</Typography>
          ) : (
            <>
              <Typography variant="body1">
                {moment(row?.created_at).format("MMMM Do, YYYY")}
              </Typography>
              {isAdmin === true && (
                <Typography variant="caption">
                  {moment(row?.created_at).format("h:mm a")}
                </Typography>
              )}
            </>
          )}
        </Grid>
        <Grid item xs={2}>
          {heading ? (
            <Typography variant="body1">Type</Typography>
          ) : (
            <Typography variant="body1">{row?.transactionType}</Typography>
          )}
        </Grid>
        <Grid item xs={2}>
          {heading ? (
            <Typography variant="body1">Status</Typography>
          ) : (
            <Typography variant="body1">{row?.status}</Typography>
          )}
        </Grid>
        <Grid item xs={2}>
          {heading ? (
            <Typography variant="body1">Total</Typography>
          ) : (
            <Typography variant="body1">{`${
              row?.transactionType === "Refund" ? "-" : ""
            }${row?.amount}${
              row?.chargeType === "Loyalty Points" ? " LP" : ""
            }`}</Typography>
          )}
        </Grid>
        {isAdmin !== true && row?.summary && row.summary !== "" && (
          <Grid item xs={12}>
            <Typography variant="caption">
              {row.summary.split("/n").join(" ")}
            </Typography>
          </Grid>
        )}
      </Grid>
    );
  };
  if (heading) {
    return <Content />;
  }
  return (
    <Grid item xs={12}>
      <Link
        href={`${isAdmin === true ? "/admin" : ""}/shop/transaction/${row?.id}`}
        underline="none"
      >
        <Content />
      </Link>
    </Grid>
  );
};
